// extracted by mini-css-extract-plugin
export default {"tabView":"previous-credits_tabView__LWAZd","tabContent":"previous-credits_tabContent__RktTG"};